import { render } from "./reviews-slider.vue?vue&type=template&id=50b730cf&scoped=true"
import script from "./reviews-slider.vue?vue&type=script&lang=js"
export * from "./reviews-slider.vue?vue&type=script&lang=js"

import "./reviews-slider.vue?vue&type=style&index=0&id=50b730cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b730cf"]])

export default __exports__